var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"solo":"","label":"Data Validation Mode","items":_vm.items,"value":_vm.value,"disabled":_vm.isDisabled,"hint":_vm.disabledHintMessage,"persistent-hint":""},on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }